'use strict';

/**
 * Factory for list views
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ListShowroomView = require('modules/collection/views/partials/list-showroom');
var ListGridView = require('modules/collection/views/partials/list-grid');
var ListTableView = require('modules/collection/views/partials/list-table');
var ListSliderView = require('modules/collection/views/partials/list-slider');

var ListFactory = function() {
    this.createListView = function(type, options) {
        var listViewClasses = {
            'grid': ListGridView,
            'list': ListTableView,
            'showroom-grid': ListShowroomView,
            'slider': ListSliderView,
        };

        var ListView = listViewClasses[type];

        if (ListView) {
            return new ListView(options);
        } else {
            console.warn('No ListView found for type:', type);
        }
    }
}

module.exports = ListFactory;